/*
 *  I15DIMSILOBOISReducer.ts
 *
 *  Created by Sébastien Hecart on 2022-06-19 18:55:20 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I15DIMSILOBOIS_State } from '@batical/types/src'

const I15DIMSILOBOIS: I15DIMSILOBOIS_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_deperdition: 2000.0,
  in_temp_consigne: 10.0,
  in_tempExtBase: 0.0,
  in_puissance_nominale_chaudiere: 150.0,
  dju_uuid: '7B22493D-4045-46F4-A5A4-1FE31B07BDC1',
  material_uuid: '9',
  in_masse_volumique: 170.0,
  in_renderement_install_bois: 60.0,
  duration_uuid: '3',
  res_pci_combu: 0.0,
  res_silo_rotatif: 0.0,
  res_silo_racleur: 0.0,
  res_silo_cylindrique: 0.0,
  res_volume_moyen: 0.0,
  mode: 'none',
  calcul_code: 'I15DIMSILOBOIS',
  dataChart: []
}

export default I15DIMSILOBOIS
